<app-usdt-change [usdt_clp_tax]="usdt_clp_tax" class="usdtChange"></app-usdt-change>
<div class="flex flex-row justify-between items-center mx-5">
  <div class="balance_container">
    <h2 [ngStyle]="{ display: hasLoaded ? '' : 'none' }" class="mb-3 font-bold">${{ saldoActual | number }} CLP$</h2>
    <img *ngIf="!hasLoaded" src="assets/loader.svg" height="60" width="60" class="mt-3 mx-auto" alt="">
    <p class="font-bold">Saldo Actual</p>
  </div>
</div>
<div class="flex flex-row justify-between items-center mx-5 mt-8">
  <button routerLink="/wallet/client/rechargeAccount"
    style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
    onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
    Recargar Saldo
  </button>
  <button (click)="emitChangeStep()"
    style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
    onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
    Comprar Criptomoneda
  </button>
</div>
